module.exports = __webpack_public_path__ + "static/media/DAT.e7c1d593.svg";